import {
  Module,
  VideoActivityData,
  MCQActivityData,
  EnglishSentenceData,
  FillInTheBlankData,
  ListeningData,
  BuildSentenceData,
  MatchData,
  CelebrateData,
} from "../activityTypes";
import {
  M2_DAD_RULE_LESSON_ID,
  M2_MENTE_RULE_LESSON_ID,
  M2_REVIEW_LESSON_ID,
} from "../flightSchoolContent";
import { DAD_WORDS, MENTE_WORDS } from "./words";

// =============================================================================
// Module 2 Activities (Cognates 2 — v4 format)
// 19 steps: DAD section → MENTE section → Mixed review
// =============================================================================

// --- Section 1: DAD Pattern (Steps 1-7) ---

const m2Step1_ES: EnglishSentenceData = {
  id: "m2-step1",
  type: "english_sentence",
  sentence:
    "I checked my {actividad} report and the {realidad} is I need to go outside.",
  cognateWords: [DAD_WORDS[1], DAD_WORDS[0]], // actividad, realidad
};

const m2Step2_Video: VideoActivityData = {
  id: "m2-step2-video",
  type: "video",
  lessonId: M2_DAD_RULE_LESSON_ID,
};

const m2Step3_MCQ: MCQActivityData = {
  id: "m2-step3-mcq",
  type: "mcq",
  question: "university",
  options: [
    { choice: "realidad", correct: false },
    { choice: "universidad", correct: true },
    { choice: "actividad", correct: false },
    { choice: "posibilidad", correct: false },
  ],
  isReverse: true,
};

const m2Step4_ES: EnglishSentenceData = {
  id: "m2-step4",
  type: "english_sentence",
  sentence:
    "The {posibilidad} of me waking up early is {completamente} zero.",
  cognateWords: [DAD_WORDS[3], MENTE_WORDS[3]], // posibilidad, completamente
};

const m2Step5_Fill: FillInTheBlankData = {
  id: "m2-step5-fill",
  type: "fill_in_the_blank",
  youtubeId: "LnlcLyIQz0k",
  chapterId: 4299,
  videoStartMs: 0,
  videoEndMs: 4900,
  spanishSentence: "Me gusta la ___",
  englishHint: "I like the community.",
  correctWord: DAD_WORDS[4], // comunidad
  incorrectWord: DAD_WORDS[0], // realidad
  extraIncorrectWords: [DAD_WORDS[2], DAD_WORDS[5]], // universidad, oportunidad
  showWordHints: true,
};

const m2Step6_Listen: ListeningData = {
  id: "m2-step6-listen",
  type: "listening",
  targetWord: DAD_WORDS[5], // oportunidad
  distractorWord: DAD_WORDS[0], // realidad
  additionalDistractors: [DAD_WORDS[1], DAD_WORDS[2]], // actividad, universidad
};

const m2Step7_Celebrate: CelebrateData = {
  id: "m2-step7-celebrate",
  type: "celebrate",
  patternLabel: "-DAD = -TY",
  words: [
    DAD_WORDS[0], // realidad
    DAD_WORDS[1], // actividad
    DAD_WORDS[2], // universidad
    DAD_WORDS[3], // posibilidad
    DAD_WORDS[4], // comunidad
    DAD_WORDS[5], // oportunidad
    MENTE_WORDS[3], // completamente (bonus from step 4)
  ],
};

// --- Section 2: MENTE Pattern (Steps 8-13) ---

const m2Step8_ES: EnglishSentenceData = {
  id: "m2-step8",
  type: "english_sentence",
  sentence:
    "I {normalmente} say I'm on my way but I haven't {exactamente} left yet.",
  cognateWords: [MENTE_WORDS[0], MENTE_WORDS[1]], // normalmente, exactamente
};

const m2Step9_Video: VideoActivityData = {
  id: "m2-step9-video",
  type: "video",
  lessonId: M2_MENTE_RULE_LESSON_ID,
};

const m2Step10_Build: BuildSentenceData = {
  id: "m2-step10-build",
  type: "build_sentence",
  correctSentence: "La realidad es una oportunidad",
  englishHint: "Reality is an opportunity",
  words: ["oportunidad", "es", "La", "una", "realidad"],
  cognateWord: DAD_WORDS[0], // realidad
  showEnglishHints: true,
  wordHints: { una: "an" },
};

const m2Step11_Listen: ListeningData = {
  id: "m2-step11-listen",
  type: "listening",
  targetWord: MENTE_WORDS[2], // rápidamente
  distractorWord: MENTE_WORDS[0], // normalmente
  additionalDistractors: [MENTE_WORDS[1], MENTE_WORDS[3]], // exactamente, completamente
};

const m2Step12_Match: MatchData = {
  id: "m2-step12-match",
  type: "match",
  pairs: [
    DAD_WORDS[1], // actividad
    DAD_WORDS[3], // posibilidad
    MENTE_WORDS[0], // normalmente
    MENTE_WORDS[1], // exactamente
    DAD_WORDS[4], // comunidad
  ],
};

const m2Step13_Celebrate: CelebrateData = {
  id: "m2-step13-celebrate",
  type: "celebrate",
  patternLabel: "-MENTE = -LY",
  words: [
    DAD_WORDS[0], // realidad
    DAD_WORDS[1], // actividad
    DAD_WORDS[2], // universidad
    DAD_WORDS[3], // posibilidad
    DAD_WORDS[4], // comunidad
    DAD_WORDS[5], // oportunidad
    MENTE_WORDS[0], // normalmente
    MENTE_WORDS[1], // exactamente
    MENTE_WORDS[2], // rápidamente
    MENTE_WORDS[3], // completamente
  ],
};

// --- Section 3: Mixed Review (Steps 14-19) ---

const m2Step14_ES: EnglishSentenceData = {
  id: "m2-step14",
  type: "english_sentence",
  sentence:
    "She {finalmente} found a {comunidad} that actually gets her.",
  cognateWords: [MENTE_WORDS[4], DAD_WORDS[4]], // finalmente, comunidad
};

const m2Step15_MCQ: MCQActivityData = {
  id: "m2-step15-mcq",
  type: "mcq",
  question: "rapidly",
  options: [
    { choice: "normalmente", correct: false },
    { choice: "rápidamente", correct: true },
    { choice: "exactamente", correct: false },
    { choice: "completamente", correct: false },
  ],
  isReverse: true,
};

const m2Step16_Video: VideoActivityData = {
  id: "m2-step16-video",
  type: "video",
  lessonId: M2_REVIEW_LESSON_ID,
};

const m2Step17_Build: BuildSentenceData = {
  id: "m2-step17-build",
  type: "build_sentence",
  correctSentence: "La universidad tiene actividad",
  englishHint: "The university has activity",
  words: ["actividad", "tiene", "La", "universidad"],
  cognateWord: DAD_WORDS[2], // universidad
  showEnglishHints: true,
  wordHints: { tiene: "has" },
};

const m2Step18_Match: MatchData = {
  id: "m2-step18-match",
  type: "match",
  pairs: [
    DAD_WORDS[5], // oportunidad
    DAD_WORDS[2], // universidad
    MENTE_WORDS[3], // completamente
    MENTE_WORDS[2], // rápidamente
    MENTE_WORDS[4], // finalmente
  ],
};

const m2Step19_Celebrate: CelebrateData = {
  id: "m2-step19-celebrate",
  type: "celebrate",
  title: "Chapter Complete!",
  isFinal: true,
  words: [...DAD_WORDS, ...MENTE_WORDS],
  patternLabels: ["-DAD = -TY", "-MENTE = -LY"],
  totalWordsUnlocked: "1000+",
};

// =============================================================================
// Module 2 Definition
// =============================================================================

export const MODULE_2: Module = {
  id: "module-2",
  name: "Cognate Patterns: DAD & MENTE",
  patterns: ["DAD", "MENTE"],
  activities: [
    // Section 1: DAD Pattern (Steps 1-7)
    m2Step1_ES,
    m2Step2_Video,
    m2Step3_MCQ,
    m2Step4_ES,
    m2Step5_Fill,
    m2Step6_Listen,
    m2Step7_Celebrate,
    // Section 2: MENTE Pattern (Steps 8-13)
    m2Step8_ES,
    m2Step9_Video,
    m2Step10_Build,
    m2Step11_Listen,
    m2Step12_Match,
    m2Step13_Celebrate,
    // Section 3: Mixed Review (Steps 14-19)
    m2Step14_ES,
    m2Step15_MCQ,
    m2Step16_Video,
    m2Step17_Build,
    m2Step18_Match,
    m2Step19_Celebrate,
  ],
};
